export const styles = {
  entityText: { mx: 2 },
  listContainer: { width: 250 },
  notificationHeaderText: { fontSize: 18, fontWeight: 700, m: 2 },
};
